var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher-header-actions" } },
    [
      _c(
        "or-button",
        {
          attrs: {
            "data-button": "cancel",
            variant: "text",
            disabled: _vm.isUpdating,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("cancel")
            },
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("HITL.common.actions.cancel")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "or-button",
        {
          attrs: { "data-button": "save", loading: _vm.isUpdating },
          on: {
            click: function ($event) {
              return _vm.$emit(_vm.actionsType)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }